import {ArrayTyper} from '@caliatys/array-typer';

function dateConstructor(date: string): Date {
  return new Date(date);
}

function numberConstructor(num: number): number {
  return num;
}

function numberFromDateConstructor(date: string): number {
  return new Date(date).getTime();
}

export class Configuration {
  configStatus: 'current'|'target';
  currentDate: ConfigurationData<number>;
  nextRecordDate: ConfigurationData<Date>;
  nextSendDate: ConfigurationData<Date>;
  nextDiagnosisDate: ConfigurationData<Date>;
  alarmThresholds: AlarmThreshold[];
  timezone: string = null;

  get configurationUpdatePayload(): any {
    const payload: any = {};

    if (this.currentDate.edit) {
      payload.currentDateShift = this.currentDate.value;
    }
    if (this.nextRecordDate.edit) {
      payload.nextRecordDate = this.nextRecordDate.value;
    }
    if (this.nextSendDate.edit) {
      payload.nextSendDate = this.nextSendDate.value;
    }
    if (this.nextDiagnosisDate.edit) {
      payload.nextDiagnosisDate = this.nextDiagnosisDate.value;
    }
    this.alarmThresholds.forEach(alarm => {
      if (alarm.edit) {
        payload.alarmThresholds = payload.alarmThresholds || [];

        const alarmPayload: any = {variableName: alarm.variableName};
        if (alarm.alarmType.edit) {
          alarmPayload.alarmType = alarm.alarmType.value;
        }
        if (alarm.hysteresis.edit) {
          alarmPayload.hysteresis = alarm.hysteresis.value;
        }
        if (alarm.upper.edit) {
          alarmPayload.upper = alarm.upper.value;
        }
        if (alarm.lower.edit) {
          alarmPayload.lower = alarm.lower.value;
        }

        payload.alarmThresholds.push(alarmPayload);
      }
    });
    return payload;
  }

  get edit(): boolean {
    return this.currentDate.edit
      || this.nextRecordDate.edit
      || this.nextSendDate.edit
      || this.nextDiagnosisDate.edit
      || this.alarmThresholds.some(alarm => alarm.edit);
  }

  constructor(obj: any) {
    this.configStatus = obj?.configStatus;
    this.currentDate = new ConfigurationData<number>(numberFromDateConstructor, obj?.currentDate);
    this.nextRecordDate = new ConfigurationData<Date>(dateConstructor, obj?.nextRecordDate);
    this.nextSendDate = new ConfigurationData<Date>(dateConstructor, obj?.nextSendDate);
    this.nextDiagnosisDate = new ConfigurationData<Date>(dateConstructor, obj?.nextDiagnosisDate);
    this.alarmThresholds = ArrayTyper.asArray(AlarmThreshold, obj?.alarmThresholds);
  }
}

export class AlarmThreshold {
  variableName: string;
  alarmType: ConfigurationData<number>;
  hysteresis: ConfigurationData<number>;
  upper: ConfigurationData<number>;
  lower: ConfigurationData<number>;

  get edit() {
    return this.alarmType.edit
      || this.hysteresis.edit
      || this.upper.edit
      || this.lower.edit;
  }

  constructor(obj: any) {
    this.variableName = obj?.variableName;
    this.alarmType = new ConfigurationData<number>(numberConstructor, obj?.alarmType);
    this.hysteresis = new ConfigurationData<number>(numberConstructor, obj?.hysteresis);
    this.upper = new ConfigurationData<number>(numberConstructor, obj?.upper);
    this.lower = new ConfigurationData<number>(numberConstructor, obj?.lower);
  }

}

export class ConfigurationData<T> {
  lastUpdateDate: Date;
  value: T;
  lastValue: T;
  edit: boolean;
  // tslint:disable-next-line:variable-name
  private _defaultValue: T = null;

  get defaultValue() {
    return this._defaultValue;
  }

  set defaultValue(value: T) {
    this._defaultValue = value;
    this.value = value;
  }


  constructor(c: (object: any) => T, obj: any) {
    this.lastUpdateDate = obj ? new Date(obj?.lastUpdateDate) : null;
    this.lastValue = obj ? c(obj.value) : null;
    this.defaultValue = obj ? c(obj?.value) : null;

    const newValue = obj ? c(obj?.newValue) : null; // Case of target installation

    if (newValue !== undefined && newValue !== null) {
      this.defaultValue = newValue;
    }
  }
}
